module.exports = __webpack_public_path__ + "assets/img/panorama-720.c49e377a.png";